import * as React from 'react';

import { MapFilters } from 'src/common/models/hotel/map-types/filter-map-model';
import { MarkerIcon } from 'src/common/models/hotel/map-types/map-marker';

import { UitkCard, UitkCardContent, UitkCardSectionSeparatorType, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkPill } from 'uitk-react-pill';

export interface MapPillsProps {
  filters: MapFilters[];
  activePills: Set<MarkerIcon>;
  onPillToggle: (marker: MarkerIcon) => void;
}

export function MapPills({ activePills, filters, onPillToggle }: MapPillsProps) {
  const handleClick = (type: MarkerIcon) => () => onPillToggle(type);

  return (
    <UitkCard className="uitk-flat-border-top uitk-flat-border-bottom">
      <UitkCardContent>
        <UitkCardTextSegment separator={UitkCardSectionSeparatorType.BOTTOM}>
          {Boolean(filters.length) &&
            filters.map(({ label, type }) => {
              const filter = MarkerIcon[type.toString()];

              return (
                <UitkPill key={label} checked={activePills.has(filter)} id={`pill-${type}`} onChange={handleClick(filter)}>
                  {label}
                </UitkPill>
              );
            })}
        </UitkCardTextSegment>
      </UitkCardContent>
    </UitkCard>
  );
}

MapPills.displayName = 'MapPills';
